import { FlightSubLOBProps } from "components/flexComponents/WizardFlightPWA/typings";
import * as React from "react";
import { FlightAddHotelCheckbox } from "components/flexComponents/WizardFlightPWA/components/FlightAddHotelCheckbox";
import { FlightAddCarCheckbox } from "components/flexComponents/WizardFlightPWA/components/FlightAddCarCheckbox";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { FlightsFareCalendar } from "./FlightsFareCalendar";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";

export const RoundtripFlight = observer((props: FlightSubLOBProps) => {
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 4, medium: 6, large: 12 };
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 6, large: 8 };
  const fareCalendarTest = "PWA_fare_calendar_home_page";
  const {
    errorInputRef,
    isRoundtripFormValid,
    numberOfErrors,
    updateInvalidFormsState,
    moreThanOneError,
  } = props.lobState;
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 6, large: 4 };
  if (isRoundtripFormValid) {
    updateInvalidFormsState();
  }

  return (
    <UitkLayoutGrid columns={mainGridColumns} space="three" className="all-t-margin-two">
      {!isRoundtripFormValid && (
        <LobErrorSummary
          locHeadingToken={props.getLocError(false)!}
          locHeadingArgs={moreThanOneError() && [numberOfErrors]}
          locLinkToken={props.getLocError(true)}
          linkClickFocusId="id-roundtrip-error"
          inputErrorRef={errorInputRef}
          colSpan={mainGridColumns}
          setInputsRefs={props.setInputsRefs}
        />
      )}
      <Location
        setInputsRefs={props.setInputsRefs}
        originField={true}
        destinationField={true}
        lobState={props.lobState}
        showSwapLocationsControl={true}
        colSpan={locationColSpan}
      />
      <Experiment name={fareCalendarTest}>
        <ExperimentControl>
          <Dates
            lobState={props.lobState}
            colSpan={datesColSpan}
            singleDateSelect={true}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <FlightsFareCalendar
            singleDate={false}
            lobState={props.lobState}
            colSpan={datesColSpan}
            singleDateSelect={true}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentVariant>
      </Experiment>
      {(props.lobState.config.enableAddHotel || props.lobState.config.enableAddCar) && (
        <UitkLayoutGridItem colSpan="all">
          <UitkLayoutFlex space="three" className="all-t-padding-two">
            {props.lobState.config.enableAddHotel && <FlightAddHotelCheckbox flightWizardState={props.lobState} />}
            {props.lobState.config.enableAddCar && <FlightAddCarCheckbox flightWizardState={props.lobState} />}
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
      )}
      {props.lobState.config.enableAddHotel && props.lobState.isAddAHotelChecked && (
        <Dates
          lobState={props.lobState}
          isPartialStay={true}
          colSpan={datesColSpan}
          setInputsRefs={props.setInputsRefs}
        />
      )}
    </UitkLayoutGrid>
  );
});
